export enum RugbyLeagueConversionGoalAttribute {
  Golden = 2991,
}
